export const gameConfigurations = {
  defaultStakeConfigurations: {
    minimumStakeAmount: 1,
    maximumStakeAmount: 1000,
    defaultStakeAmount: 10,
    step: 5,
    presetStakes: [5, 20, 100, 500],
  },
}
